module.exports = __webpack_public_path__ + "img/ios_on.0008b8a1.png";